import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/auth';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="bg-white border-b border-heynay-border py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-heynay-dark-gray">
              Heynay Admin
            </Link>
            <div className="flex items-center gap-4">
              <span className="text-heynay-gray font-semibold">
                {user?.fullName || user?.email}
              </span>
              <button
                onClick={handleLogout}
                className="px-6 py-2 border border-heynay-border rounded-3xl text-heynay-dark-gray font-medium hover:bg-heynay-light-gray transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;
